import { ReactNode, forwardRef } from 'react';
import * as StyledCheckbox from './styled/checkbox';

export interface CheckboxProps extends StyledCheckbox.RootProps {
  indicatorOn?: ReactNode;
  indicatorOff?: ReactNode;
}

export const Checkbox = forwardRef<HTMLLabelElement, CheckboxProps>(
  ({ indicatorOff, indicatorOn, ...props }, ref) => {
    const { children, ...rootProps } = props;

    return (
      <StyledCheckbox.Root ref={ref} {...rootProps}>
        <StyledCheckbox.Control>
          <StyledCheckbox.Indicator>{indicatorOn}</StyledCheckbox.Indicator>
        </StyledCheckbox.Control>
        {children && <StyledCheckbox.Label>{children}</StyledCheckbox.Label>}
        <StyledCheckbox.HiddenInput />
      </StyledCheckbox.Root>
    );
  },
);

Checkbox.displayName = 'Checkbox';
